import React from 'react';
import ManagementState from './management/managementState';

const QuotasModuleState = props => {
    return <ManagementState>{props.children}</ManagementState>;
};

export default QuotasModuleState;
